import React, { useState } from "react";
import { Button, FormGroup, Grid, TextField } from "@material-ui/core";
import { withRouter } from "react-router-dom";

const InsertModel = ({ updateModel, handleCloseModal }) => {
  const [keyName, setKeyName] = useState("");
  const [valueName, setValueName] = useState("");
  const [error, setError] = useState({});

  const handleInsertModel = () => {
    const errList = {};
    if (!keyName) errList.keyName = "Key is reqrired";
    if (!valueName) errList.valueName = "Value is reqrired";
    console.log("Object.keys(errList).length", Object.keys(errList).length);
    if (Object.keys(errList).length === 0) {
      console.log({ keyName, valueName });
      updateModel({ keyName, valueName });
    } else setError(errList);
  };

  return (
    <div style={{height: "250px"}}>
      <h4>Model Insertion</h4>
      <Grid container spacing={3}>
        <Grid item sm={12}>
          <FormGroup>
            <TextField
              required
              id="key-name"
              label="Key Name"
              value={keyName}
              onChange={(e) => {
                setKeyName(e.target.value);
                setError((prevState) => {
                  const newState = { ...prevState };
                  delete newState["keyName"];
                  return newState;
                });
              }}
              fullWidth
              margin="normal"
              error={!!error.keyName}
              helperText={error.keyName}
            />
            <TextField
              required
              id="value-name"
              label="Value"
              value={valueName}
              fullWidth
              onChange={(e) => {
                setValueName(e.target.value);
                setError((prevState) => {
                  const newState = { ...prevState };
                  delete newState["valueName"];
                  return newState;
                });
              }}
              margin="normal"
              error={!!error.valueName}
              helperText={error.valueName}
            />
          </FormGroup>
        </Grid>
        <Grid item sm={12} style={{ display: "flex", justifyContent: "end", marginTop: "-1rem" }}>
          <Button
            variant="contained"
            style={{
              marginTop: "10px",
              color: "black",
              height: "40px",
              marginRight: "1rem",
            }}
            onClick={handleCloseModal}
          >
            Close
          </Button>
          <Button
            variant="contained"
            style={{
              marginTop: "10px",
              backgroundColor: "#622ad8",
              color: "#000",
              height: "40px",
            }}
            onClick={handleInsertModel}
          >
            Update Model
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default withRouter(InsertModel);
